import { useEffect, useState } from "react"
import {
  faEllipsisVertical,
  faPlus,
  faGear,
  faTrash,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  Button,
  Dropdown,
  Nav,
  Container,
  Table,
} from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import {
  DeleteRequest,
  GetRequest,
  PutRequest,
} from "../../Utils/hooks/ApiHandler"
import useLocalStorageState from "use-local-storage-state"
import { useGetRequest } from "../../Utils/hooks/QueryHandler"
import { Pagination } from "../../pages/Pagination"
import DeleteModal from "../DeleteModal"
import { toast } from "sonner"
import "./InvoiceOrder.css"
import {
  formatDate,
  formatToINR,
} from "../../Utils/helpers/commonhelper"
import RecurringInvoiceDetails from "./RecurringInvoiceDetails"
import nodata from "../../Utils/assets/img/leads_no_data_found.png"
import { TableSkeleton } from "../../Utils/skeletonLoader/TableSkeleton"
import { AuthorizationCard } from "../../pages/AuthorizationCard"
import { ColumnConfigurator } from "../../pages/ColumnConfigurator"

export const RecurringInvoices = () => {
  const navigate = useNavigate()
  const [customer, setCustomer] = useLocalStorageState("customer", {
    token: {},
  })

  const customer_id = customer?.customer_details?.customer_id || 1
  const token = customer?.token?.authorization || ""
  const rf = customer?.token?.authentication || ""
  const extras = { customer, setCustomer, rf, navigate }
  const headers = {
    Authorization: token,
    Authentication: rf,
  }

  const [showInvoiceOrderDetails, setShowInvoiceOrderDetails] = useState(false)
  const [isMyApproval, setMyApproval] = useState(false)
  const [allSalesOrder, setAllSalesOrder] = useState([])
  const [salesOrderId, setsalesOrderId] = useState()
  const [departmentToDelete, setDepartmentToDelete] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [loading, setLoading] = useState(false)
  // States for using pagination
  // Calculate total pages

  const [limit, setLimit] = useState(25)
  const [offset, setOffset] = useState(0)
  const [search, setSearch] = useState("")
  const [inputSearch, setInputSearch] = useState("")
  const [visibleColumns, setVisibleColumns] = useState([]);

  const [tempColumns, setTempColumns] = useState([]);
  // Debounced search effect
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      setSearch(inputSearch.trim())
      setOffset(0)
    }, 300)
    return () => clearTimeout(debounceTimer)
  }, [inputSearch])
  const params = {
    limit,
    offset,
    search: search,
  }

  const endPoint = isMyApproval
    ? `/sales/fetchMyApprovals/${customer_id}/${customer?.customer_details?.id}`
    : `/sales/fetchAllOrders/${customer_id}`

  const {
    data: salesOrderData,
    error,
    refetch: fetchSalesOrder,
    isLoading,
    isError,
  } = useGetRequest(
    `invoice/fetchRecurringInvoice/${customer_id}/${customer?.customer_details?.id}/${customer?.customer_details?.user_type}`,
    "getInvoiceOrder",
    headers,
    extras,
    params
  )

  // poermissions for recurring invoice 
  const permission = customer.customer_details?.permission;
  const isRecurring = permission?.find(c => c.module_name?.toLowerCase()?.split(" ")?.join("_") === "recurring_invoice")
  const recurringPermission = permission?.filter(c => c.module_name?.toLowerCase()?.split(" ")?.join("_") === "recurring_invoice")
  const user_type = Number(customer.customer_details?.user_type)
  const recurringGrant = {
    isView: user_type !== 1 ? Boolean(Number(isRecurring && recurringPermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "recurring_invoice")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(isRecurring && recurringPermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "recurring_invoice")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(isRecurring && recurringPermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "recurring_invoice")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(isRecurring && recurringPermission?.find(c => c.feature_name?.toLowerCase()?.split(" ")?.join("_") === "recurring_invoice")?.delete)) : true,
  }

  useEffect(() => {
    fetchSalesOrder()
    setAllSalesOrder([]) // Reset before setting new data

    if (salesOrderData?.status === "success") {
      setAllSalesOrder(salesOrderData.data)
    } else if (salesOrderData?.status === "fail") {
      setAllSalesOrder([])
    } else if (isError) {
      console.error("Error fetching quotation:", error)
    }
  }, [salesOrderData])

  const pageCount = Math.ceil(salesOrderData?.total_count / limit)
  const [editData, setEditData] = useState(null)
  const [isEditOpen, setIsEditOpen] = useState(false)
  const [isClone, setIsClone] = useState(false)

  const handleEditClick = async (id) => {
    if (!id) return
    try {
      const res = await GetRequest(
        `/sales/fetchDetailsOfSpecificOrder/${id}`,
        { headers },
        extras
      )
      if (res.status === "success") {
        const editDataToSet = res.data
        setEditData(editDataToSet)
        setIsEditOpen(true)
        setIsClone(false)
        setsalesOrderId(id)
      }
    } catch (error) {
      console.error(error)
    }
  }
  const [detailPageId, setDetailPageId] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [toCancelQuotation, setToCancelQuotation] = useState()
  const [rejectReason, setRejectReason] = useState("")

  const handleCloseModal = () => {
    setShowModal(false)
    setRejectReason("")
    setLoading(false)
  }

  const handleConfirm = async () => {
    setLoading(true)
    try {
      const payload = {
        quotation_id: toCancelQuotation,
        customer_id: customer_id,
        canceletion_reason: rejectReason,
        user_login_id: customer?.customer_details?.id,
      }
      const res = await PutRequest(
        `quotation/cancelQuotation`,
        payload,
        { headers },
        extras
      )
      if (!res || res.status === "fail") {
        return toast.error(res.message || "something went wrong")
      }
      if (res.status === "success") {
        toast.success(res.message)
        setToCancelQuotation()
        setRejectReason("")
        await fetchSalesOrder()
        setShowModal(false)
      }
    } catch (error) {
      return
    } finally {
      setShowModal(false)
      setLoading(false)
    }
  }

  const handleCloneClick = async (saleOrder) => {
    const id = saleOrder.id
    if (!id) return

    navigate(`/cloneInvoice/${id}`)
  }

  const handleCloseEdit = () => {
    setEditData(null)
    setIsEditOpen(false)
    setIsClone(false)
  }
  // Handle page change from react-paginate
  const handlePageChange = (selectedItem) => {
    setOffset(selectedItem.selected)
  }

  const handleAddClick = (quotation) => {
    const dataToSend = {
      key1: quotation.quotation_id,
      key2: isMyApproval,
    }

    // navigate('/detailquotation', { state: dataToSend });
  }

  const onDelete = (id) => {
    setDepartmentToDelete(id)
    setShowDeleteModal(true)
  }

  // Confirm delete and call API
  const handleConfirmedDelete = async () => {
    setLoading(true)
    try {
      const item = allSalesOrder.find((d) => d.id === departmentToDelete)
      if (!item) {
        return
      }

      const res = await DeleteRequest(
        `invoice/deleteRecurringInvoice/${departmentToDelete}/${customer_id}/${customer?.customer_details?.id}`,
        { headers },
        extras
      )

      if (res?.status === "success") {
        toast.success(res.message)
        await fetchSalesOrder()
      } else if (res.status === "fail") {
        toast.error(res.message)
      }
    } catch (error) {
      console.error("Delete error:", error)
    } finally {
      setLoading(false)
      setShowDeleteModal(false)
      setDepartmentToDelete(null)
    }
  }

  const handleDetailPageClicked = (saleOrder) => {
    setDetailPageId(saleOrder?.id)
    setShowInvoiceOrderDetails(true)
  }

  const columnOptions = [
    // { key: "sn", label: "#",locked: true },
    { key: "invoice_number", label: "Invoice Number", mandatory: true },
    { key: "sale_no", label: "Sales Number" },
    { key: "start_date", label: "Start Date" },
    { key: "contact_name", label: "Customer Name" },
    { key: "confirmed", label: "Payment" },
    { key: "items", label: "Amount" },
    { key: "due_date", label: "End Date" },
    // { key: "owner_full_name", label: "Action" },
    // { key: "deal_name", label: "Deal" },
    // { key: "quotation_status", label: "Quotation Status" },
  ];

  // Initialize columns for the table - ALL columns visible by default
  const [columns, setColumns] = useState(() => {
    const saved = localStorage.getItem("visibleRecurringColumns");
    const allColumnKeys = columnOptions.map(col => col.label);
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {
        console.error("Error parsing visible columns:", e);
      }
    }
    return allColumnKeys;
  });

  return (
    <>
      <DeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmedDelete}
        isLoading={loading}
        message={"Are you sure you want to permanently delete this invoice?"}
      />
      <div className="pb-1 d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center gap-2">
          <h3
            className="mb-0 d-flex gap-2 align-items-center"
            style={
              isMyApproval
                ? { fontSize: 14, cursor: "pointer", color: '#4dabf4' }
                : {
                  whiteSpace: "nowrap",
                  fontWeight: 300,
                  fontSize: "22px",
                  cursor: "pointer",
                  color: "#4dabf4"
                }
            }
            onClick={() => setMyApproval(false)}
          >
            All Recurring Invoices
          </h3>
        </div>

        <div
          className="d-flex align-items-center gap-1"
          style={{
            height: "39px",
            position: "absolute",
            right: 0,
            top: "0.5rem",
          }}
        >
          {/* search bar */}
          <div className=" position-relative">
            <input
              type="text"
              style={{
                fontSize: "12px",
                paddingLeft: "36px",
                height: "35px",
              }}
              className="form-control "
              value={inputSearch}
              onChange={(e) => {
                setInputSearch(e.target.value)
                setOffset(0)
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault()
                  setSearch(inputSearch)
                  setOffset(0)
                }
              }}
            />
            <i
              class="fa-solid fa-magnifying-glass"
              style={{
                position: "absolute",
                marginTop: "-26px",
                zIndex: 1,
                marginLeft: "13px",
              }}
            ></i>
            {inputSearch.length > 0 && (
              <i
                class="fa-solid fa-xmark"
                style={{
                  position: "absolute",
                  marginTop: "-26px",
                  zIndex: 1,
                  right: 0,
                  marginRight: "13px",
                  cursor: "pointer",
                }}
                onClick={() => setInputSearch("")}
              ></i>
            )}
          </div>

          <ColumnConfigurator
            columnOptions={columnOptions}
            columns={columns}
            setColumns={setColumns}
            storageKey="recurringColumns"
            visibleKey="visibleRecurringColumns"
          />

          <Button
            style={{
              maxHeight: "35px",
              color: "white",
              fontSize: "14px",
              border: "1px solid",
              alignItems: "center",
              paddingRight: "10px",
              backgroundColor: "rgb(122, 58, 94)"
            }}

            type="button"
            className="btn btn-default"
            onClick={() => {
              if (!recurringGrant?.isCreate) {
                toast.warning("You are not authorized for this action!")
                return
              }
              navigate("/createRecurringOrder")
            }}
          >
            <FontAwesomeIcon icon={faPlus} /> Add
          </Button>
        </div>
      </div>

      {
        recurringGrant?.isView ?
          <Container
            fluid
            style={{
              fontFamily: "'Poppins', sans-serif",
              height: "calc(100vh - 14rem)",
              backgroundColor: "white",
              padding: 0,
              animation: "cardEntry 1s ease-out forwards",
            }}
            className="mt-3 p-0"
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                width: "100%",
              }}
            >
              <div
                className="listStyleForContact container-table"
                style={{
                  flex: allSalesOrder?.length > 10 ? 1 : "auto",
                  overflow: allSalesOrder?.length > 10 ? "auto" : "visible",
                  width: "100%",
                  maxHeight: allSalesOrder?.length > 10 ? "100%" : "auto",
                  scrollbarWidth: "thin"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.scrollbarColor = "#e0e0e0 white"

                }}
              >
                <Table style={{
                  width: "100%", tableLayout: "auto", backgroundColor: 'white', marginBottom: "0px", borderCollapse: "separate",
                  borderSpacing: "0px",
                }}>
                  <thead style={{ zIndex: 101 }}>
                    <tr>
                      <th
                        className="text-start  pinned-column last-pinned-column  bulk-selection-cell customize-cell-width"
                        style={{
                          width: 60,
                          minWidth: 60,
                          maxWidth: 60,
                          left: 0,
                        }}
                      >
                        <span>#</span>
                      </th>
                      {columns.map((col, index) => (
                        <th
                          key={`header-${index}`}
                          style={{
                            textAlign:
                              col !== "Invoice Number" &&
                                col !== "Sales Number" &&
                                col !== "Customer Name" &&
                                col !== "Start Date"
                                ? "center"
                                : "left",
                          }}
                        >
                          {col}
                        </th>
                      ))}
                      <th>
                        Action{" "}
                        <i
                          className="fa-solid fa-sort"
                          style={{ fontSize: "0.6rem" }}
                        ></i>
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ textAlign: "start" }}>
                    {isLoading ? (
                      <TableSkeleton columnCount={columns.length + 2} />
                    ) : (
                      <>
                        {allSalesOrder && allSalesOrder.length > 0 ? (
                          allSalesOrder.map((saleOrder, index) => (
                            <tr key={saleOrder?.id || index}>
                              <td>{offset * limit + index + 1}</td>
                              {console.log("saleOrder", saleOrder.sale_no)}
                              {console.log("columns", columns)}
                              {/* Dynamic cells based on columns order */}
                              {columns.map((col, cellIndex) => {
                                console.log("col", col)
                                switch (col) {
                                  case "Invoice Number":
                                    return (
                                      <td
                                        key={`cell-${index}-${cellIndex}`}
                                        style={{ color: "#0099ff", cursor: "pointer" }}
                                        data-bs-target="#saleOrderDetails"
                                        data-bs-toggle="offcanvas"
                                        onClick={() => handleDetailPageClicked(saleOrder)}
                                      >
                                        {saleOrder.invoice_number}
                                      </td>
                                    );

                                  case "Sales Number":
                                    return (
                                      <td key={`cell-${index}-${cellIndex}`}>
                                        {saleOrder.sale_no}{" "}
                                        <i className="fa-regular fa-envelope"></i>
                                      </td>
                                    );

                                  case "Start Date":
                                    return (
                                      <td key={`cell-${index}-${cellIndex}`}>
                                        {formatDate(saleOrder.start_date)}
                                      </td>
                                    );

                                  case "Customer Name":
                                    return (
                                      <td key={`cell-${index}-${cellIndex}`} style={{ maxWidth: "80px" }}>
                                        {saleOrder.contact_name}
                                      </td>
                                    );

                                  case "Payment":
                                    return (
                                      <td key={`cell-${index}-${cellIndex}`} style={{ textAlign: "center" }}>
                                        Confirmed
                                      </td>
                                    );

                                  case "Amount":
                                    return (
                                      <td key={`cell-${index}-${cellIndex}`} style={{ textAlign: "center" }}>
                                        {formatToINR(
                                          JSON.parse(saleOrder.items)[0]?.["grand-total"] || 0
                                        )}
                                      </td>
                                    );

                                  case "End Date":
                                    return (
                                      <td key={`cell-${index}-${cellIndex}`} style={{ textAlign: "center" }}>
                                        {formatDate(saleOrder?.end_date)}
                                      </td>
                                    );

                                  default:
                                    return <td key={`cell-${index}-${cellIndex}`}>-</td>;
                                }
                              })}

                              {/* Actions column */}
                              <td key={`actions-${index}`} style={{ textAlign: "center" }}>
                                <div className="d-flex justify-content-center">
                                  <FontAwesomeIcon
                                    className="text-danger"
                                    title="Delete"
                                    onClick={() => {
                                      if (!recurringGrant?.isDelete) {
                                        toast.warning("You are not authorized for this action!")
                                        return
                                      }
                                      onDelete(saleOrder.id)
                                    }}
                                    style={{
                                      width: "15px",
                                      height: "15px",
                                      cursor: "pointer",
                                    }}
                                    icon={faTrash}
                                  />
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan={columns.length + 2}
                              style={{ textAlign: "center", color: "gray" }}
                            >
                              <div
                                className="d-flex justify-content-center align-items-center"
                                style={{ padding: "2rem" }}
                              >
                                <img
                                  src={nodata}
                                  alt="No data found"
                                  style={{ width: "17rem" }}
                                />
                              </div>
                            </td>
                          </tr>
                        )}

                        {allSalesOrder?.length > 10 && (
                          <tr
                            className="no-hover-row"
                            style={{
                              backgroundColor: "#ffffff",
                              marginTop: "0px !important",
                              marginBottom: "0px !important",
                            }}
                          >
                            <td colSpan={columns.length + 2}>
                              <div style={{ padding: 0 }}>
                                <div
                                  className="d-flex justify-content-between align-items-center gap-2 mt-0"
                                  style={{
                                    padding: "0.5rem 0",
                                  }}
                                >
                                  <div className="pagination-left">
                                    <p
                                      className="mb-0"
                                      style={{
                                        fontSize: "14px",
                                        paddingRight: "10rem",
                                      }}
                                    >
                                      Showing {offset + 1} of{" "}
                                      {pageCount !== 0 ? pageCount : pageCount + 1}
                                    </p>
                                  </div>
                                  <div className="pagination-right d-flex gap-2 align-items-center">
                                    <select
                                      style={{ minWidth: "78px", height: "2.3rem" }}
                                      onChange={(e) => {
                                        setLimit(Number(e.target.value));
                                        setOffset(0);
                                      }}
                                      id="limit"
                                      className="form-control form-select"
                                    >
                                      <option value={25}>25</option>
                                      <option value={100}>100</option>
                                      <option value={200}>200</option>
                                      <option value={300}>300</option>
                                    </select>
                                    <div className="d-flex align-items-center gap-3">
                                      <Pagination
                                        offset={offset}
                                        setOffset={setOffset}
                                        handlePageChange={handlePageChange}
                                        pageCount={pageCount}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                  </tbody>
                </Table>
              </div>

              {allSalesOrder?.length <= 10 && (
                <div
                  style={{
                    padding: "0.5rem 0",
                    backgroundColor: "white",
                    borderTop: "1px solid #e0e0e0",
                    width: "100%",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center gap-2">
                    <div className="pagination-left">
                      <p className="mb-0" style={{ fontSize: "14px" }}>
                        Showing {offset + 1} of {pageCount !== 0
                          ? pageCount
                          : pageCount + 1}
                      </p>
                    </div>
                    <div className="pagination-right d-flex gap-2 align-items-center">
                      <select
                        style={{ minWidth: "78px", height: '2.3rem' }}
                        onChange={(e) => {
                          setLimit(Number(e.target.value))
                          setOffset(0)
                        }}
                        id="limit"
                        className="form-control form-select"
                      >
                        <option value={25}>25</option>
                        <option value={100}>100</option>
                        <option value={200}>200</option>
                        <option value={300}>300</option>
                      </select>
                      <div className="d-flex align-items-center gap-3">
                        <Pagination
                          offset={offset}
                          setOffset={setOffset}
                          handlePageChange={handlePageChange}
                          pageCount={pageCount}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {showInvoiceOrderDetails && (
              <RecurringInvoiceDetails
                fetchSalesOrder={fetchSalesOrder}
                show={showInvoiceOrderDetails}
                setShowSalesOrderDetails={setShowInvoiceOrderDetails}
                detailPageId={detailPageId}
                handleClose={() => setShowInvoiceOrderDetails(false)}
              />
            )}
          </Container>
          :
          <AuthorizationCard></AuthorizationCard>
      }
    </>
  )
}